import { Modal } from 'components/ui/Modal';

export interface ScenarioConsolidationEvidence {
  scenarioId: string;
  scenarioTitle?: string;
  sectionNames: string[];
}

export interface ConsolidationPreviewItem {
  scenarioId: string;
  scenarioTitle?: string;
  targetSectionName: string;
}

interface Props {
  evidence: ScenarioConsolidationEvidence[];
  consolidationPreview?: ConsolidationPreviewItem[];
  onKeep: () => void;
  onUpdate: () => void;
  onClose: () => void;
}

export const ScenarioConsolidationChoiceModal = ({
  evidence,
  consolidationPreview,
  onKeep,
  onUpdate,
  onClose
}: Props) => {
  return (
    <Modal
      title="Scenario questions split across sections"
      onClose={onClose}
      boxClassName="w-[480px]"
    >
      <div className="space-y-4">
        <p className="text-sm text-black">
          Some scenario questions are split across multiple sections. You can keep the current structure or consolidate so each scenario appears in one section.
        </p>
        <div className="space-y-4 max-h-40 overflow-y-auto custom-scrollbar">
          {evidence.map((item, i) => (
            <li key={item.scenarioId || i} className="border-tertiary pb-2 border-l-2 pl-2">
              <p className="text-sm font-medium text-black mb-1">
                Scenario: {item.scenarioTitle || ''}
              </p>
              <p className="text-xs text-black/70 mb-1">In sections:</p>
              <ul className="list-disc list-inside space-y-0.5 text-sm text-black/90">
                {item.sectionNames.map((name, j) => (
                  <li key={j}>{name}</li>
                ))}
              </ul>
            </li>
          ))}
        </div>
        {consolidationPreview && consolidationPreview.length > 0 && (
          <div>
            <p className="text-sm font-medium text-black mb-2">Changes that will be made if you choose Update:</p>
            <ul className="list-disc list-inside space-y-1 text-sm text-black/90 max-h-40 overflow-y-auto custom-scrollbar">
              {consolidationPreview.map((item, i) => (
                <li key={item.scenarioId || i} className="border-tertiary pb-2 border-l-2 pl-2">
                  <strong>{item.scenarioTitle || 'Scenario'}</strong> will be moved to <strong>{item.targetSectionName}</strong>
                </li>
              ))}
            </ul>
          </div>
        )}
        <div className="flex gap-3 pt-2">
          <button type="button" className="secondaryBtn flex-1" onClick={onKeep}>
            Keep current structure
          </button>
          <button type="button" className="secondaryBtn flex-1" onClick={onUpdate}>
            Update
          </button>
        </div>
      </div>
    </Modal>
  );
};
